import { useVirtualizer, type Virtualizer } from '@tanstack/react-virtual';

/**
 * Thin pass-through wrapper around TanStack Virtual's `useVirtualizer()`.
 *
 * `useVirtualizer()` returns functions that aren't stable across renders,
 * so React Compiler can't safely memoize any component that calls it
 * directly (react-hooks/incompatible-library). Funneling every call site
 * through this one small wrapper (which has nothing else to memoize)
 * keeps the known incompatibility contained to a single file instead of
 * scattered across every component that renders a windowed list -- see
 * the matching eslint.config.mjs override for why the lint rule itself
 * can't reach zero here regardless.
 */
export function useSafeVirtualizer<TScrollElement extends Element, TItemElement extends Element>(options: Parameters<typeof useVirtualizer<TScrollElement, TItemElement>>[0]): Virtualizer<TScrollElement, TItemElement> {
  return useVirtualizer(options);
}